"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Payment = /** @class */ (function () {
    function Payment() {
    }
    return Payment;
}());
exports.default = Payment;
//# sourceMappingURL=Payment.js.map